import React from "react"
import PropTypes from "prop-types"

import * as am4core from '@amcharts/amcharts4/core';
import { XYChart } from '@amcharts/amcharts4/.internal/charts/types/XYChart';
import { ValueAxis } from '@amcharts/amcharts4/.internal/charts/axes/ValueAxis';
import { DateAxis } from '@amcharts/amcharts4/.internal/charts/axes/DateAxis';
import { LineSeries } from '@amcharts/amcharts4/.internal/charts/series/LineSeries';
import { XYCursor } from '@amcharts/amcharts4/.internal/charts/cursors/XYCursor';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

import { color } from '@amcharts/amcharts4/.internal/core/utils/Color';

import './index.css'

const DEFAULT_COLORS = [
  color('#1ABC9C'),
  color('#FEBC77'),
  color('#2980B9'),
  color('#F1C40F'),
  color('#FF7043'),
  color('#9B59B6'),
  color('#27AE60'),
  color('#E74C3C'),
  color('#2ECC71'),
  color('#8DB7D7'),
  color('#E67E22'),
  color('#8E44AD'),
  color('#16A085'),
  color('#6D4C41'),
  color('#F39C12'),
  color('#D35400'),
  color('#3498DB'),
  color('#AD1457'),
  color('#66BB6A'),
  color('#ACE1AF'),
  color('#F7E7CE'),
  color('#FFB7C5'),
  color('#7B3F00'),
];


am4core.useTheme(am4themes_animated);

class LineChart extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.chart = am4core.create("chartdiv", XYChart);
    this.chart.cursor = new XYCursor();
    this.chart.cursor.lineY.disabled = true;

    this.initColors();
    this.chart.colors.reuse = true;

    this.dateAxis = this.chart.xAxes.push(new DateAxis());
    this.dateAxis.renderer.minGridDistance = 50;
    this.dateAxis.renderer.grid.template.location = 0.5;
    this.dateAxis.startLocation = 0.5;
    this.dateAxis.endLocation = 0.5;

    const dateTemplate = this.dateAxis.renderer.labels.template;
    dateTemplate.fontSize = 14;
    dateTemplate.fill = color('#CEDBDC');

    this.categoryAxis = this.chart.yAxes.push(new ValueAxis());

    let labelTemplate = this.categoryAxis.renderer.labels.template;
    labelTemplate.fill = color('#CEDBDC');
    labelTemplate.fontSize = 14;

    this.chart.cursor.xAxis = this.categoryAxis;

    this.createSeries();
    this.createSeries2();
    this.createSeries3();
    this.updateChartsData();

  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  componentDidUpdate(prevProps) {

  }

  initColors = () => {
    this.chart.colors.list = DEFAULT_COLORS;
  };

  createSeries = () => {
    this.series = this.chart.series.push(new LineSeries());
    this.series.dataFields.valueY = "value1";
    this.series.dataFields.dateX = "date";
    this.series.strokeWidth = 2;
    this.series.minBulletDistance = 10;
    this.series.tooltipText = "[bold]{value1}";
    this.series.tooltip.pointerOrientation = "vertical";
    this.series.strokeWidth = 3;
    this.series.tensionX = 0.8;

    let filter = this.series.filters.push(new am4core.DropShadowFilter());
    filter.color = am4core.color("#1ABC9C");
    filter.dx = 10;
    filter.dy = 0;
    filter.blur = 10;
    filter.opacity = 0.5;
  }

  createSeries2 = () => {
    this.series2 = this.chart.series.push(new LineSeries());
    this.series2.dataFields.valueY = "value2";
    this.series2.dataFields.dateX = "date";
    this.series2.strokeWidth = 2;
    this.series2.minBulletDistance = 10;
    this.series2.tooltipText = "[bold]{value2}";
    this.series2.tooltip.pointerOrientation = "vertical";
    this.series2.strokeWidth = 3;
    this.series2.tensionX = 0.8;

    let filter = this.series2.filters.push(new am4core.DropShadowFilter());
    filter.color = am4core.color("#FEBC77");
    filter.dx = 10;
    filter.dy = 0;
    filter.blur = 10;
    filter.opacity = 0.5;
  }

  createSeries3 = () => {
    this.series3 = this.chart.series.push(new LineSeries());
    this.series3.dataFields.valueY = "value3";
    this.series3.dataFields.dateX = "date";
    this.series3.strokeWidth = 4;
    this.series3.minBulletDistance = 10;
    this.series3.tooltipText = "[bold]{value3}";
    this.series3.tooltip.pointerOrientation = "vertical";
    this.series3.tensionX = 0.8;

    let filter = this.series3.filters.push(new am4core.DropShadowFilter());
    filter.color = am4core.color("#2980B9");
    filter.dx = 10;
    filter.dy = 0;
    filter.blur = 10;
    filter.opacity = 0.5;
  }

  updateChartsData = () => {

    this.chart.data =  [
      {date:new Date(2019,5,12), value1:50, value2:48, value3: 37, previousDate:new Date(2019, 5, 5)},
      {date:new Date(2019,5,13), value1:53, value2:51, value3: 50, previousDate:new Date(2019, 5, 6)},
      {date:new Date(2019,5,14), value1:56, value2:58, value3: 54, previousDate:new Date(2019, 5, 7)},
      {date:new Date(2019,5,15), value1:52, value2:53, value3: 59,previousDate:new Date(2019, 5, 8)},
      {date:new Date(2019,5,16), value1:48, value2:44, value3: 65, previousDate:new Date(2019, 5, 9)},
      {date:new Date(2019,5,17), value1:47, value2:42, value3: 53,previousDate:new Date(2019, 5, 10)},
      {date:new Date(2019,5,18), value1:59, value2:55, value3: 60, previousDate:new Date(2019, 5, 11)}
    ]
  }

  render() {
    return (
      <div style={{ width: '99%'}}>
        <div id="chartdiv" style={{ width: '100%', height: "400px" }}></div>
      </div>
    )
  }
}

LineChart.propTypes = {
  dataset: PropTypes.array,
}

export default LineChart

